const data = {
  id: "health",
  title: "Healthcare & Hospital System",
  intro: "A nonprofit that raises prices, kills competition, and pays its executives millions isn't a charity — it's a business with a tax exemption. Huntsville Hospital calls itself a nonprofit. The public is still waiting on the proof.",
  tabs: [
    {
      id: "overview",
      label: "Overview",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "hospital_system",
      label: "Hospital System",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "coverage_gaps",
      label: "Coverage Gaps",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "low_pay_labor",
      label: "Low Pay & Labor",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "costs_billing",
      label: "Costs & Billing",
      stats: [],
      issues: [],
      trail: []
    }
  ]
};
export default data;
